import { render } from "./EmptyBoxIcon.vue?vue&type=template&id=2c786b54&ts=true"
import script from "./EmptyBoxIcon.vue?vue&type=script&lang=ts"
export * from "./EmptyBoxIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__